export const handleDownloadFile = () => {
  const link = document.createElement('a');
  link.href = '/Relatorio-AtualizacaoSaaS.pdf';
  link.download = 'Relatorio-AtualizacaoSaaS.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
